export const url = 'https://api.hiphone.am'
export const urlLink = 'https://api.hiphone.am'